var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-Switch',{on:{"on-change":function (flag) { return _vm.item.onChange && _vm.item.onChange(_vm.item, _vm.formItems); }},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})}
var staticRenderFns = []

export { render, staticRenderFns }